import React, { memo } from 'react';
import TextValidation from './Validation/TextValidation';
import BooleanValidation from './Validation/BooleanValidation';
import NumberValidation from './Validation/NumberValidation';
import DateValidation from './Validation/DateValidation';
import ImageValidation from './Validation/ImageValidation';
import LocationValidation from './Validation/LocationValidation';
import SwitchValidation from './Validation/SwitchValidation';
import SliderValidation from './Validation/SliderValidation';
import CheckboxValidation from './Validation/CheckboxValidation';
import CheckGroupValidation from './Validation/CheckGroupValidation';
import TextareaValidation from './Validation/TextareaValidation';
import DropdownValidation from './Validation/DropdownValidation';
import ObjectValidation from './Validation/ObjectValidation';
import UploadValidation from './Validation/UploadValidation';
import DataSetValidation from './Validation/DataSetValidation';
import { ScrollView } from 'react-native-gesture-handler';
import updateStoreHandler from './utils/updateStoreHandler';

const AdditionalOptions = ({ componentType, index, item }: { componentType: string, index: number, item: any }) => {


  const ComponentOptions = ({ type }) => {
    switch (type) {
      case 'dataSet': 
        return (
          <DataSetValidation index={index} item={item.validation}/>
        );
      case "string":
        return (
          <TextValidation index={index} item={item.validation}/>
        );
      case "boolean":
        return (
          <BooleanValidation index={index} item={item.validation}/>
        );
      case "number":
        return (
          <NumberValidation index={index} item={item.validation}/>
        );
      case "dateTime":
        return (
          <DateValidation index={index} item={item.validation}/>
        );
      case "dropDown":
        return (
          <DropdownValidation index={index} item={item.validation}/>
        );
      case "object":
        return (
          <ObjectValidation index={index} item={item.validation}/>
        );
      case "image":
        return (
          <ImageValidation index={index} item={item.validation}/>
        );
      case "location":
        return (
          <LocationValidation index={index} item={item.validation}/>
        );
      case "switch":
        return (
          <SwitchValidation index={index} item={item.validation}/>
        );
      case "slider":
        return (
          <SliderValidation index={index} item={item.validation}/>
        );
      case "checkbox":
        return (
          <CheckboxValidation index={index} item={item.validation}/>
        );
        case 'checkGroup':
        return (
          <CheckGroupValidation index={index} item={item.validation}/>
        );
      case "file":
        return (
          <UploadValidation index={index} item={item.validation}/>
        );
      default:
        return null;
    }
  };

  return (
    <ScrollView showsVerticalScrollIndicator={false} nestedScrollEnabled style={{maxHeight: 300}}>
        <ComponentOptions type={componentType} />
    </ScrollView>
  )
}
export default memo(AdditionalOptions);
